import Counter from './Counter';
import Game from './Game';
import { TeamNode } from './graph';
import Timer from './Timer';

export type TeamData = {
	id: string;
	name: string;
}

export class Team {
	data: TeamData;
	game: Game;
	counters: Counter[] = [];
	timers: Timer[] = [];

	constructor(data: TeamNode, game: Game) {
		this.data = data;
		this.game = game;
	}

	get client () {
		return this.game.client;
	}

	get isHome () {
		return this === this.game.home_team;
	}

	get isAway () {
		return this === this.game.away_team;
	}
}
